<template>
  <div>
    <BaseButton
      :title="alternateTitle || $t('Next question')"
      :theme="theme"
      class="mb-2"
      type="submit"
      @click.native="$emit('next')"
    />
    <BaseButton
      :title="$t('Continue later')"
      class="mb-8"
      theme="outlined"
      @click.native.prevent="continueLater()"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseButton from '../../components/BaseButton.vue';

export default {
  name: 'KycButtons',
  components: {
    BaseButton,
  },
  props: {
    theme: {
      type: String,
      default: 'disabled',
    },
    alternateTitle: {
      type: String,
      default: null,
    },
  },
  methods: {
    ...mapActions('kyc', ['update']),
    continueLater() {
      this.update();
      localStorage.lastKycPage = this.$route.name;
      if (this.$route.params) {
        localStorage.lastKycPageIdParam = this.$route.params.id;
      }
      this.$router.push('/opportunities');
    },
  },
};
</script>
